import { Box, CircularProgress, Stack, TextField } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';

/** Match create-media disabled title field: no underline while the name is locked in. */
export const contributorBusyNameFieldSx: SxProps<Theme> = {
  '& .MuiInputBase-root': {
    '&::before': { display: 'none' },
    '&::after': { display: 'none' },
    '&:hover::before': { display: 'none' },
    '&.Mui-disabled::before': { display: 'none' },
  },
};

/** Locked name + spinner while a contributor create/add settles (media upload title parity). */
export function ContributorBusyNameField({ label, name, testId }: { label: string; name: string; testId?: string }) {
  return (
    <Stack direction="row" alignItems="flex-start" spacing={1} sx={{ mb: 1 }} data-testid={testId}>
      <TextField
        fullWidth
        variant="standard"
        label={label}
        value={name}
        disabled
        slotProps={{ input: { readOnly: true } }}
        sx={contributorBusyNameFieldSx}
      />
      <Box sx={{ display: 'flex', alignItems: 'center', pt: 2, flexShrink: 0 }} aria-hidden>
        <CircularProgress size={20} />
      </Box>
    </Stack>
  );
}
